(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kazu-bestsellers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-kz-bs]').forEach(function (raiz) {
    var pista = raiz.querySelector('[data-kz-pista]');
    if (!pista) return;
    raiz.addEventListener('click', function (ev) {
      var boton = ev.target.closest('[data-kz-dir]');
      if (!boton) return;
      var paso = pista.clientWidth * 0.8 * Number(boton.dataset.kzDir);
      pista.scrollBy({ left: paso, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kazu-espacios"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-kz-esp]').forEach(function (raiz) {
    var enlaces = raiz.querySelectorAll('[data-kz-indice]');
    var fotos = raiz.querySelectorAll('[data-kz-foto]');

    function activar(indice) {
      enlaces.forEach(function (el) {
        el.classList.toggle('is-activo', el.dataset.kzIndice === indice);
      });
      fotos.forEach(function (el) {
        el.classList.toggle('is-activo', el.dataset.kzFoto === indice);
      });
    }

    raiz.addEventListener('pointerover', function (ev) {
      var enlace = ev.target.closest('[data-kz-indice]');
      if (enlace) activar(enlace.dataset.kzIndice);
    });

    raiz.addEventListener('focusin', function (ev) {
      var enlace = ev.target.closest('[data-kz-indice]');
      if (enlace) activar(enlace.dataset.kzIndice);
    });

    /* Parallax: la columna izquierda sube, la derecha baja */
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var izq = raiz.querySelector('[data-kz-lado="izq"]');
      var der = raiz.querySelector('[data-kz-lado="der"]');
      if (izq && der) {
        var pendiente = false;
        var mover = function () {
          pendiente = false;
          var r = raiz.getBoundingClientRect();
          var vh = window.innerHeight || 1;
          var p = (vh - r.top) / (vh + r.height);
          p = Math.min(1, Math.max(0, p));
          var d = (p - 0.5) * 90;
          izq.style.transform = 'translateY(' + (-d).toFixed(1) + 'px)';
          der.style.transform = 'translateY(' + d.toFixed(1) + 'px)';
        };
        window.addEventListener('scroll', function () {
          if (!pendiente) {
            pendiente = true;
            window.requestAnimationFrame(mover);
          }
        }, { passive: true });
        mover();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
